import { isNode } from './fc_env'

let nextId = 0

export function fcResetDomId(): void {
  if (!isNode()) {
    return
  }
  nextId = 0
}
export function fcGetDomId(): string {
  const val = nextId.toString(36)
  nextId = (nextId + 1) % 1000
  return val
}
